import {useQuery} from '@tanstack/react-query';
import {getCurrentUser} from 'aws-amplify/auth';

import {sessionKeys} from '../keys';

/**
 * Y a-t-il un utilisateur Cognito connu d'Amplify sur cette page ? `true` si
 * `getCurrentUser()` répond, `false` s'il lève (aucun jeton en stockage).
 *
 * C'est la porte d'entrée de `useMeQuery` et `usePremiumStatusQuery`. `SessionProvider`
 * enveloppe TOUTES les routes, y compris les publiques — `/chat`, chargé par l'extension
 * dans un iframe sur linkedin.com, sans jeton Cognito ; `/signin` ; les pages de partage.
 * Sans cette porte, les deux requêtes de session partaient de là sans condition, et comme le
 * pool d'identités refuse les invités, Amplify les envoyait NON signées : 403
 * `MissingAuthenticationTokenException` à chaque ouverture du composer LinkedIn, pour tout
 * le monde (PERFECTPOST-WEB-10X).
 *
 * `getCurrentUser()` lit les jetons en stockage local ; il ne renouvelle le jeton du pool
 * d'utilisateurs que s'il est périmé et ne touche JAMAIS au pool d'identités. Ne pas le
 * remplacer par `fetchAuthSession()`, qui tenterait un `GetId` sur le pool d'identités à
 * chaque chargement de `/chat`. `staleTime: Infinity` : la réponse ne change que sur
 * connexion ou déconnexion, et ces deux événements invalident la clé (`refreshSession`,
 * écouteur `Hub` de `App.tsx`).
 */
export function useAuthenticatedUserQuery() {
  return useQuery({
    queryKey: sessionKeys.authenticated(),
    queryFn: async (): Promise<boolean> => {
      try {
        await getCurrentUser();
        return true;
      } catch {
        return false;
      }
    },
    staleTime: Infinity,
    retry: false,
  });
}
